import React from 'react';
import styles from './MobileAdStructure.module.scss';
import {IProduct} from 'data/interfaces/products';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import {Container, Grid} from '@material-ui/core';
import {Unless, When} from 'react-if';
import ShowMoreText from 'gui/components/showMoreText';
import AdPrices from '../../../adPrices/AdPrices';
import AdControl from '../../..//adControl';
import AdPurchase from '../../../adPurchase/AdPurchase';
import GenericImageSquare from '../../../genericImageSquare';
import TopTab from '../../components/topTab';
import {IGuiReducerState} from 'data/redux/reducers/guiReducer';
import {eSavingsType} from 'gui/components/listPage/components/ad/components/adPurchase/components/adSavings';

export interface IMobileAdStructureProps {
  product: IProduct;
  displaySquare: any;
  cardTitle: any;
  specialDetails: any;
  specialDetails2: any;
  timeRemaining: number;
  salePriceLabel?: any;
  originalPriceLabel?: any;
  originalPrice: number;
  originalPriceClassName?: string;
  salePrice?: number;

  additionalRows: any;

  hideControl?: boolean | any;
  hideStatus?: boolean;
  showPurchase?: boolean;
  statusToText?: (status: number) => string;
  status?: number;
  statusComponent?: any;

  view?: (id: number) => void;
  edit?: (id: number) => void;
  delete?: (id: number) => void;

  loading?: boolean;

  gui?: IGuiReducerState;
  savingsType?: eSavingsType;

}

const MobileAdStructure = (props: IMobileAdStructureProps) => {
  return (
    <Card className={styles.mobileAdStructure}>
      {(props.loading || !props.displaySquare) ?
        <GenericImageSquare loading={true} className={styles.GenericImageSquare}/>
        : <props.displaySquare product={props.product} gui={props.gui} className={styles.GenericImageSquare}>
          <div className={styles.infoSquare}>
            <Grid item xs={12} style={{padding: 0}}>
              <Typography className={styles.topTitle} gutterBottom variant="h6" component="h6">
                {props.cardTitle}
              </Typography>
            </Grid>
            <Grid item xs={12} style={{padding: 0}}>
              {props.specialDetails}
            </Grid>
          </div>
        </props.displaySquare>}
      <TopTab {...props} className={styles.topTab}/>
      <CardContent>
        <Container>
          <Grid container>
            <Grid item xs={12} sm={12}>
              <AdPrices className={styles.prices}
                        salePriceLabel={props.salePriceLabel}
                        originalPriceLabel={props.originalPriceLabel}
                        originalPrice={props.originalPrice}
                        originalPriceClassName={props.originalPriceClassName}
                        salePrice={props.salePrice || props.product.saleDetails.askingPrice}
                        currency={props.product.saleDetails.currency}
                        loading={props.loading}
              />
            </Grid>
          </Grid>
        </Container>
      </CardContent>
      <CardActions>
        <Container>
          <Grid container>
            <When condition={!!props.showPurchase}>
              {() => <Grid item xs={12} style={{padding: 0, marginLeft: 'auto', marginRight: 'auto'}}>
                <AdPurchase
                  product={props.product}
                  savingsType={props.savingsType}
                  loading={props.loading}
                />
              </Grid>}
            </When>
          </Grid>
        </Container>
        <Unless condition={props.hideControl === true}>
          {() => <>
            <AdControl
              className={styles.control}
              hideControl={props.hideControl}
              product={props.product}
              edit={props.edit}
              view={props.view}
              delete={props.delete}
              loading={props.loading}
            />
          </>
          }
        </Unless>
      </CardActions>
    </Card>
  );
};

MobileAdStructure.defaultProps = {
  product: {},
  displaySquare: null,
  cardTitle: null,
  specialDetails: null,
  specialDetails2: null,
  timeRemaining: 0,
  originalPrice: 0,
  additionalRows: null,

  hideControl: false,
  hideStatus: false,

  view: () => {
  },
  edit: () => {
  },
  delete: () => {
  },
};
export default MobileAdStructure;
